import { render, staticRenderFns } from "./sort-agent.vue?vue&type=template&id=e29e6506&scoped=true&"
import script from "./sort-agent.vue?vue&type=script&lang=js&"
export * from "./sort-agent.vue?vue&type=script&lang=js&"
import style0 from "./sort-agent.vue?vue&type=style&index=0&id=e29e6506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29e6506",
  null
  
)

export default component.exports